function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import applyReducer from './applyReducer';
import { constantsRegistry } from '../constants/tableConstantsFactory';
const deferredConstants = constantsRegistry('deferred');
const formConstants = constantsRegistry('form');
const initState = {};

/**
 *  Avoid repeated serverIndex calls by setting state[currentCabinet][currentFilter].loading
 */
const index = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  // index view uses path for redux state so individual fields can store their own state
  [action.indexQuery.path]: _objectSpread(_objectSpread({}, state[action.indexQuery.path] || {}), {}, {
    hasNext: false,
    loading: true
  })
});
const path = action => action.query.path;

/**
 *  On failure move the error to the filter's state
 */
const indexFail = (state, action) => {
  const {
    error
  } = action;
  return _objectSpread(_objectSpread({}, state), {}, {
    // update the current cabinet with the top-level state
    [path(action)]: _objectSpread(_objectSpread({}, state[path(action)]), {}, {
      options: [],
      error,
      indexQuery: {}
    })
  });
};

// clear only happens on editor load.
const clear = () => initState;
const hasNext = action => {
  var _action$data, _action$query;
  return (action === null || action === void 0 || (_action$data = action.data) === null || _action$data === void 0 ? void 0 : _action$data.length) > (((_action$query = action.query) === null || _action$query === void 0 || (_action$query = _action$query.paging) === null || _action$query === void 0 ? void 0 : _action$query.size) || 20);
};
const options = (state, action) => {
  const {
    data
  } = action;
  return data;
};

/**
 *  Using detailReducerFactory as the default was setting 'form' state rather than 'deferred'.
 *  Need to add loading for the current record, even if multiple paths are specified.
 */
const show = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  // unlike index views, the detail view uses the id for redux state to avoid reloading the same
  // related record within a collection
  [action.id]: {
    loading: true
  }
});

/**
 *  Load the record from the db into state:
 *    { deferred: { [id]: { active } } }
 *  Form search (formSearchField) returns lightweight records; we mark them with overview: true
 *  so readReferencedContentBehavior can load full content from the server when the requested
 *  content path is missing.
 */
const showSuccess = (state, action) => {
  var _action$data2;
  const content = (action === null || action === void 0 || (_action$data2 = action.data) === null || _action$data2 === void 0 ? void 0 : _action$data2.content) || {};
  const active = _objectSpread(_objectSpread({}, content), {}, {
    overview: true
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    [action.id]: _objectSpread(_objectSpread({}, state[action.id]), {}, {
      active,
      loading: false
    })
  });
};

/**
 *  Look for forms being set in form.editorCache.formCache and add them to deferred. Caching is
 *  called by behaviors, like readReferencedContentBehavior, during format evaluation. Format
 *  evaluation is called before components are loaded, so formSearchFields can look in deferred
 *  state for the cached form.
 */
const setFormsInDeferred = (state, action) => {
  const {
    name = '',
    value = {}
  } = action;

  // only cache forms
  if (value && name.includes('formCache')) {
    const {
      id
    } = value;
    return _objectSpread(_objectSpread({}, state), {}, {
      [id]: {
        active: value,
        loading: false
      }
    });
  }
  return state;
};

/**
 *  Load the result from a formSearchField search into state:
 *    { deferred: { [path]: { indexQuery } } }
 */
const indexSuccess = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  [path(action)]: _objectSpread(_objectSpread({}, state[path(action)]), {}, {
    indexQuery: action.query,
    options: options(state, action),
    hasNext: hasNext(action),
    loading: false,
    error: false
  })
});
const reducers = {
  [deferredConstants.INDEX]: index,
  [deferredConstants.SHOW]: show,
  [deferredConstants.SHOW_SUCCESS]: showSuccess,
  [deferredConstants.INDEX_FAIL]: indexFail,
  [deferredConstants.INDEX_SUCCESS]: indexSuccess,
  [deferredConstants.CLEAR]: clear,
  [formConstants.SET_EDITOR_CACHE_VALUE]: setFormsInDeferred
};
export default applyReducer(reducers, initState);